import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import LSBdH2HeadLine from "../../molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import LSRgH1HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import MainBtn from "../../atoms/button/mainBtn";
import LSBdDisplay02 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay02";

import useDisplay from "../../../hooks/useDisplay";
import { route } from "../../../router/route";
import PCContainer from "../../atoms/layout/pcContainer";
import { fileUrl } from "../../../api/api";
import ReviewSwiper from "./reviewSwiper";
import LSBdBody01 from "../../molecules/text/linSeedKr/Bd/lsBdBody01";
import LSBdDisplay03 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay03";
import styled from "styled-components";
import LSBdH1HeadLine from "../../molecules/text/linSeedKr/Bd/lsBdH1HeadLine";
import ReviewItem from "../../organisms/lecture/reviewItem";
import LSRgDisplay02 from "../../molecules/text/linSeedKr/Rg/lsRgDisplay02";
import LineSeedKrBd from "../../atoms/text/lineSeedKr/lineSeedKrBd";
import LineSeedKrRg from "../../atoms/text/lineSeedKr/lineSeedKrRg";
import LSBdCaption02 from "../../molecules/text/linSeedKr/Bd/lsBdCaption02";
import LSRgH2HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import { formatNumberWithCommas } from "../../../util/formatNumber";

function DetailTop({
  lectureInfo,
  reviewList,
  setIsLoginCheckModal,
  scrapFunc,
  isScrap,
  isScrapProcessing,
  reviewClicked,
  lectureCheckFunc,
  isProcessing,
}) {
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  const navigate = useNavigate();
  const isSubscribed = sessionStorage.getItem("membership") === "true";

  return (
    <>
      <div
        style={{
          width: "100%",
          background: "#EDEDFF80",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <PCContainer
          style={{
            flexDirection: "column",
            padding: isSmall ? "0px" : "60px 0px",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              margin: isSmall ? "20px" : "0px 0px 20px 0px",
            }}
          >
            <LSRgH1HeadLine
              onClick={() => {
                navigate(route.home);
              }}
              style={{
                color: "#6F7480",
                fontSize: isSmall ? 12 : 16,
                lineHeight: isSmall ? "14.4px" : "22.4px",
                cursor: "pointer",
              }}
            >
              HOME
            </LSRgH1HeadLine>
            <img
              src="/assets/icons/right_text.svg"
              style={{
                margin: "0px 12px",
                width: isSmall ? 5 : "auto",
                height: isSmall ? 10 : "auto",
              }}
              alt="right_text"
            />
            <LSRgH1HeadLine
              onClick={() => {
                if (
                  lectureInfo?.lectureCategory?.lectureCategoryType ===
                  "FINANCE_STUDY"
                ) {
                  navigate(route.study_list);
                } else {
                  navigate(route.lecture_list);
                }
              }}
              style={{
                color: "#6F7480",
                fontSize: isSmall ? 12 : 16,
                lineHeight: isSmall ? "14.4px" : "22.4px",
                cursor: "pointer",
              }}
            >
              {lectureInfo?.lectureCategory?.lectureCategoryType ===
              "FINANCE_STUDY"
                ? "금융 스터디"
                : "영상 강의"}
            </LSRgH1HeadLine>
            <img
              src="/assets/icons/right_text.svg"
              style={{
                margin: "0px 12px",
                width: isSmall ? 5 : "auto",
                height: isSmall ? 10 : "auto",
              }}
              alt="right_text"
            />
            <LSRgH1HeadLine
              onClick={() => {
                if (
                  lectureInfo?.lectureCategory?.lectureCategoryType ===
                  "FINANCE_STUDY"
                ) {
                  navigate(
                    `${route.study_list}?page=1&categoryValue=${lectureInfo?.lectureCategory?.id}`,
                  );
                } else {
                  navigate(
                    `${route.lecture_list}?page=1&categoryValue=${lectureInfo?.lectureCategory?.id}`,
                  );
                }
              }}
              style={{
                cursor: "pointer",
                color: "#6F7480",
                fontSize: isSmall ? 12 : 16,
                lineHeight: isSmall ? "14.4px" : "22.4px",
              }}
            >
              {lectureInfo?.lectureCategory?.title}
            </LSRgH1HeadLine>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: isSmall ? "column" : "row",
            }}
          >
            <div
              style={{
                width: isSmall ? "100%" : 585,
                marginRight: isSmall ? 0 : 30,
              }}
            >
              <img
                src={
                  lectureInfo?.thumbnailServerFileName
                    ? `${fileUrl}/${lectureInfo?.thumbnailServerFileName}`
                    : ""
                }
                style={{
                  height: isSmall ? "auto" : 373,
                  width: isSmall ? "100%" : 585,
                  marginBottom: isSmall ? 0 : 33,
                  borderRadius: isSmall ? 0 : 15,
                }}
                alt="video"
              />
              {isSmall ? null : reviewList.length > 0 ? (
                <ReviewSwiper
                  dataList={reviewList}
                  reviewClicked={reviewClicked}
                />
              ) : null}
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                padding: isSmall ? 20 : 0,
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                {lectureInfo?.lectureCategory ? (
                  <div
                    style={{
                      border: "1px solid #5050FF",
                      borderRadius: 30,
                      background: "#fff",
                      padding: isSmall ? "6px 12px" : "6px 14px",
                      alignSelf: "flex-start",
                    }}
                  >
                    <LSBdBody01
                      style={{
                        color: "#5050FF",
                        fontSize: isSmall ? 10 : 14,
                        lineHeight: isSmall ? "12px" : "19.6px",
                      }}
                    >
                      {lectureInfo?.lectureCategory.title}
                    </LSBdBody01>
                  </div>
                ) : null}

                {/* {lectureInfo?.tag
                  ? lectureInfo?.tag.map((item, index) => {
                      return (
                        <div
                          key={index}
                          style={{
                            border: "1px solid #5050FF",
                            borderRadius: 30,
                            background: "#fff",
                            padding: isSmall ? "6px 12px" : "6px 14px",
                            alignSelf: "flex-start",
                          }}
                        >
                          <LSBdBody01
                            style={{
                              color: "#5050FF",
                              fontSize: isSmall ? 10 : 14,
                              lineHeight: isSmall ? "12px" : "19.6px",
                            }}
                          >
                            {item}
                          </LSBdBody01>
                        </div>
                      );
                    })
                  : null} */}
              </div>

              <LSBdDisplay03
                style={{
                  color: "#000000",
                  marginTop: isSmall ? 4 : 8,
                  marginBottom: isSmall ? 4 : 8,
                  fontSize: isSmall ? 24 : 32,
                  lineHeight: isSmall ? "33.6px" : "44.8px",
                }}
              >
                {lectureInfo?.title}
              </LSBdDisplay03>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                {/* <LSRgH1HeadLine
                  style={{
                    color: "#6F7480",
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  {lectureInfo?.lectureCategory?.title}
                </LSRgH1HeadLine>
                <div
                  style={{
                    height: isSmall ? 12 : 16,
                    width: 1,
                    marginLeft: isSmall ? 14 : 8,
                    marginRight: isSmall ? 14 : 8,
                    background: "#6F7480",
                  }}
                /> */}
                <img
                  style={{
                    width: 16,
                    height: 16,
                    marginRight: 4,
                  }}
                  src={"/assets/icons/star_3d.png"}
                  alt="star_3d"
                />
                <LSRgH1HeadLine
                  style={{
                    color: "#6F7480",
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  {Number(lectureInfo?.reviewScore ?? 0).toFixed(1)}
                </LSRgH1HeadLine>
                <div
                  style={{
                    height: isSmall ? 12 : 16,
                    width: 1,
                    marginLeft: isSmall ? 14 : 8,
                    marginRight: isSmall ? 14 : 8,
                    background: "#6F7480",
                  }}
                />
                <LSRgH1HeadLine
                  style={{
                    color: "#6F7480",
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  {formatNumberWithCommas(lectureInfo?.reviewCount)}개의
                  수강후기
                </LSRgH1HeadLine>
              </div>

              <div
                style={{
                  height: 1,
                  width: "100%",
                  background: "#DBDDE0",
                  marginTop: isSmall ? 16 : 40,
                  marginBottom: isSmall ? 16 : 20,
                }}
              />

              <TopTextContain $isSmall={isSmall}>
                <TopRightText
                  style={{
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  수강기간
                </TopRightText>
                <TopLeftText
                  style={{
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  {lectureInfo?.limitFlag
                    ? "무제한"
                    : `${formatNumberWithCommas(lectureInfo?.period)}일`}
                </TopLeftText>
              </TopTextContain>
              <TopTextContain $isSmall={isSmall}>
                <TopRightText
                  style={{
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  커리큘럼
                </TopRightText>
                <TopLeftText
                  style={{
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  총 {formatNumberWithCommas(lectureInfo?.curriculumCount)}강
                </TopLeftText>
              </TopTextContain>
              <TopTextContain $isSmall={isSmall}>
                <TopRightText
                  style={{
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  강사명
                </TopRightText>
                <TopLeftText
                  style={{
                    fontSize: isSmall ? 12 : 16,
                    lineHeight: isSmall ? "14.4px" : "22.4px",
                  }}
                >
                  {lectureInfo?.instructorName}
                </TopLeftText>
              </TopTextContain>

              <div style={{ marginTop: isSmall ? 16 : 52 }}>
                {lectureInfo?.price === 0 || isSubscribed ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      height: isSmall ? 45 : 63,
                    }}
                  >
                    <LSRgH2HeadLine
                      style={{
                        color: "#000000",
                        fontSize: isSmall ? 16 : 18,
                        lineHeight: isSmall ? "22.4px" : "25.2px",
                      }}
                    >
                      총 결제금액
                    </LSRgH2HeadLine>
                    <img
                      style={{
                        height: isSmall ? 45 : "auto",
                        width: isSmall ? 79 : "auto",
                      }}
                      src="/assets/icons/free.svg"
                      alt="free"
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: isSmall ? 16 : 4,
                      }}
                    >
                      <LSRgH2HeadLine
                        style={{
                          color: "#000000",
                          fontSize: isSmall ? 16 : 18,
                          lineHeight: isSmall ? "22.4px" : "25.2px",
                        }}
                      >
                        총 결제금액
                      </LSRgH2HeadLine>
                      <LSBdDisplay02
                        style={{
                          color: "#101113",
                        }}
                      >
                        {formatNumberWithCommas(lectureInfo?.price)}원
                      </LSBdDisplay02>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        height: isSmall ? 45 : 63,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <img
                          style={{
                            width: isSmall ? 16 : 28,
                            height: isSmall ? 16 : 28,
                            marginRight: 6,
                          }}
                          src="/assets/icons/coin.png"
                          alt="coin"
                        />
                        <LSBdH2HeadLine
                          style={{
                            color: "#000000",
                            marginRight: 6,
                            fontSize: isSmall ? 12 : 18,
                            lineHeight: isSmall ? "auto" : "25.2px",
                          }}
                        >
                          멤버십 구독하면?
                        </LSBdH2HeadLine>
                        <GradientBtn
                          onClick={() => {
                            if (sessionStorage.getItem("isLogin") === "true") {
                              navigate(route.my_page_payment_subscribe);
                            } else {
                              setIsLoginCheckModal(true);
                            }
                          }}
                        >
                          <LSBdCaption02
                            style={{
                              color: "#fff",
                            }}
                          >
                            구독하기
                          </LSBdCaption02>
                        </GradientBtn>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <LineSeedKrRg
                          style={{
                            color: "#6F7480",
                            fontSize: isSmall ? 20 : 30,
                            fontWeight: 400,
                            marginRight: 10,
                            textDecoration: "line-through",
                            marginTop: 10,
                          }}
                        >
                          {formatNumberWithCommas(lectureInfo?.price)}원
                        </LineSeedKrRg>
                        <GradientText
                          style={{
                            fontSize: isSmall ? 32 : 45,
                            fontWeight: 700,
                          }}
                        >
                          0원
                        </GradientText>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginTop: isSmall ? 16 : 26,
                }}
              >
                <div
                  aria-disabled={isScrapProcessing}
                  onClick={() => {
                    if (sessionStorage.getItem("isLogin") === "true") {
                      scrapFunc();
                    } else {
                      setIsLoginCheckModal(true);
                    }
                  }}
                  style={{
                    minWidth: isSmall ? 42 : 73,
                    height: isSmall ? 46 : 60,
                    border: "1px solid #DBDDE0",
                    background: "#fff",
                    cursor: "pointer",
                    borderRadius: 15,
                    justifyContent: "center",
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  <img
                    src={
                      isScrap
                        ? "/assets/icons/bookmark_a.png"
                        : "/assets/icons/bookmark_d.png"
                    }
                    style={{
                      height: isSmall ? 20 : 32,
                      width: isSmall ? 20 : 32,
                    }}
                    alt="bookmark_d"
                  />
                </div>

                <MainBtn
                  disabled={isProcessing}
                  onClick={() => {
                    if (sessionStorage.getItem("isLogin") === "true") {
                      lectureCheckFunc();
                    } else {
                      setIsLoginCheckModal(true);
                    }
                  }}
                  style={{
                    marginLeft: isSmall ? 16 : 29,
                    height: isSmall ? 46 : 60,
                  }}
                >
                  <LSRgDisplay02
                    style={{
                      color: "#FFFFFF",
                      textAlign: "center",
                      fontSize: isSmall ? 16 : 24,
                      lineHeight: isSmall ? "22.4px" : "33.6px",
                    }}
                  >
                    {isProcessing ? "처리 중..." : "수강하기"}
                  </LSRgDisplay02>
                </MainBtn>
              </div>

              {isSmall ? (
                <OverflowXHidden
                  style={{
                    marginTop: 31,
                  }}
                >
                  {reviewList.map((item) => {
                    return (
                      <ReviewItem
                        data={item}
                        key={item.id}
                        reviewClicked={reviewClicked}
                      />
                    );
                  })}
                </OverflowXHidden>
              ) : null}
            </div>
          </div>
        </PCContainer>
      </div>
    </>
  );
}

export default DetailTop;

const TopTextContain = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${(props) => (props.$isSmall ? "6px" : "8px")};
`;

const TopRightText = styled(LSBdH1HeadLine)`
  width: 55px;
  margin-right: 18px;
  color: #898e99;
`;

const TopLeftText = styled(LSRgH1HeadLine)`
  color: #000000;
`;

const GradientBtn = styled.div`
  background: linear-gradient(
    271.53deg,
    #a0ffff -62.69%,
    #2e4be6 46.03%,
    #4c4cac 106.75%
  );

  padding: 7px 14px;
  border-radius: 8px;
  cursor: pointer;
`;

const GradientText = styled(LineSeedKrBd)`
  background: linear-gradient(
    251.64deg,
    #a0ffff -2.48%,
    #2e4be6 57.38%,
    #4c4cac 90.82%
  );

  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const OverflowXHidden = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  overflow-x: auto;
  width: 100%;
  justify-content: flex-start;

  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* 인터넷 익스플로러 */
  scrollbar-width: none; /* 파이어폭스 */
`;
